// src/context/QueueContext.js
import { createContext, useContext } from "react";

export const QueueContext = createContext(null);

export const useQueue = () => {
  const ctx = useContext(QueueContext);
  if (!ctx) {
    // Fallback: agar context nahi mila toh direct call karo
    return { enqueue: (fn) => fn() };
  }
  return ctx;
};